__turbopack_context__.v({
  "body": "_9MLkCa_body",
  "icon": "_9MLkCa_icon",
  "trigger": "_9MLkCa_trigger",
});
